import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ManufacturersApi - axios parameter creator
 * @export
 */
const ManufacturersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All manufacturers
         * @param {boolean} [isFeatured] Get all or get by feature property true / false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublic: async (isFeatured, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetAllPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, enrich, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdsAdmin: async (request_body, enrich, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetByIdsAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {string} [syncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySyncCode: async (syncCode, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetBySyncCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (syncCode !== undefined) {
                localVarQueryParameter['syncCode'] = syncCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl: async (url, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetByUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForId: async (id, options = {}) => {
            const localVarPath = `/v1/Manufacturers/GetForId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ManufacturerToken, options = {}) => {
            const localVarPath = `/v1/Manufacturers/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ManufacturerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (term, top, options = {}) => {
            const localVarPath = `/v1/Manufacturers/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Manufacturers/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q, page, psize, options = {}) => {
            const localVarPath = `/v1/Manufacturers/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ManufacturerToken, options = {}) => {
            const localVarPath = `/v1/Manufacturers/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ManufacturerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ManufacturersApi - functional programming interface
 * @export
 */
const ManufacturersApiFp = function (configuration) {
    const localVarAxiosParamCreator = ManufacturersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get All manufacturers
         * @param {boolean} [isFeatured] Get all or get by feature property true / false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPublic(isFeatured, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPublic(isFeatured, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getAllPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdsAdmin(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdsAdmin(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getByIdsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {string} [syncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBySyncCode(syncCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBySyncCode(syncCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getBySyncCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUrl(url, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUrl(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getByUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.getForId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ManufacturerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ManufacturerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(term, top, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(term, top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ManufacturerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ManufacturerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturersApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ManufacturersApi - factory interface
 * @export
 */
const ManufacturersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ManufacturersApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All manufacturers
         * @param {boolean} [isFeatured] Get all or get by feature property true / false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublic(isFeatured, options) {
            return localVarFp.getAllPublic(isFeatured, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, enrich, options) {
            return localVarFp.getByIds(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdsAdmin(request_body, enrich, options) {
            return localVarFp.getByIdsAdmin(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {string} [syncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySyncCode(syncCode, options) {
            return localVarFp.getBySyncCode(syncCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl(url, options) {
            return localVarFp.getByUrl(url, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForId(id, options) {
            return localVarFp.getForId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ManufacturerToken, options) {
            return localVarFp.insert(ManufacturerToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(term, top, options) {
            return localVarFp.lookup(term, top, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q, page, psize, options) {
            return localVarFp.search(q, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ManufacturerToken} [ManufacturerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ManufacturerToken, options) {
            return localVarFp.update(ManufacturerToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ManufacturersApi - object-oriented interface
 * @export
 * @class ManufacturersApi
 * @extends {BaseAPI}
 */
class ManufacturersApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getAll(options) {
        return ManufacturersApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get All manufacturers
     * @param {boolean} [isFeatured] Get all or get by feature property true / false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getAllPublic(isFeatured, options) {
        return ManufacturersApiFp(this.configuration).getAllPublic(isFeatured, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getById(id, options) {
        return ManufacturersApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} [request_body]
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getByIds(request_body, enrich, options) {
        return ManufacturersApiFp(this.configuration).getByIds(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {Array<number>} [request_body]
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getByIdsAdmin(request_body, enrich, options) {
        return ManufacturersApiFp(this.configuration).getByIdsAdmin(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {string} [syncCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getBySyncCode(syncCode, options) {
        return ManufacturersApiFp(this.configuration).getBySyncCode(syncCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getByUrl(url, options) {
        return ManufacturersApiFp(this.configuration).getByUrl(url, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    getForId(id, options) {
        return ManufacturersApiFp(this.configuration).getForId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {ManufacturerToken} [ManufacturerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    insert(ManufacturerToken, options) {
        return ManufacturersApiFp(this.configuration).insert(ManufacturerToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {string} [term]
     * @param {number} [top]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    lookup(term, top, options) {
        return ManufacturersApiFp(this.configuration).lookup(term, top, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    remove(id, options) {
        return ManufacturersApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    search(q, page, psize, options) {
        return ManufacturersApiFp(this.configuration).search(q, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {ManufacturerToken} [ManufacturerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturersApi
     */
    update(ManufacturerToken, options) {
        return ManufacturersApiFp(this.configuration).update(ManufacturerToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ManufacturersApi, ManufacturersApiAxiosParamCreator, ManufacturersApiFactory, ManufacturersApiFp };
//# sourceMappingURL=manufacturers-api.js.map
